<template>
    <div class="w-full main-header flex justify-center items-center">
        <h1>Consigue tus entradas con esmientrada</h1>
       
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.main-header {
    height: $heightHeader;
    background-color: $colorHeader;
    font-size: 36px;
    // font-size: 49px;
    font-weight: 900;
    background-image: linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)),url('@/assets/images/header-background.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    h1 {
        font-size: 48px;
        text-shadow: 4px 4px #00000040;
        text-align: center;
    }
}
</style>